<template>
    <div v-if="landesverbandLocal.id==='14' || landesverbandLocal.id==='1'">
        <v-card-title class="px-3 pt-2">
            Einsatz ohne gültiges Attest
        </v-card-title>
        <v-card-subtitle class="px-3 pb-2">
            {{landesverbandLocal.name}} {{sportJahr.replace('_', '/')}}
        </v-card-subtitle>
        <einsatz-ohne-attest :lv-id="landesverbandLocal.id"></einsatz-ohne-attest>
    </div>
</template>

<script>
import EinsatzOhneAttest from "@/views/ergebnisdienst/doppelstart/einsatzOhneAttest";
export default {
    name: "attestFehlt",
    components: {EinsatzOhneAttest},
    props: ['sportJahr', 'lvId'],
    computed: {
        landesverbandLocal(){
            return this.lvId !== 'NationaleLigen' ? this.$store.state.local.landesverbaende
                    .find(lv => lv.nameShort.trim() === this.lvId) :
                this.$store.state.local.nationaleLigen;
        },
    },
}
</script>

<style scoped>

</style>